/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import * as app from "../../services/AppService";
import AgentHeader from "./AgentHeader";
import AgentNavBar from "./AgentNavBar";

export default function AgentLayout(props: { children :any}) {
    const agentRouts = useSelector((store:any) => store.data.routs);
    const options = useSelector((store: any) => store.data.options);
    const appOptions = app.options();

    const [mobileMode, setMobileMode] = useState(window.innerWidth <= 768);
    const [model, setModel] = useState({
        menu: [],
        parentName: "",
        Level: 0,
        navigation: [],
        ActiveIndex: -1,
    });

    const [control, setControl] = useState({
        showAgentInfo: true,
        isMenuOpen: !mobileMode,
        menuData: [],
    });

    function checkWidth() {
        const w = window.innerWidth;
        if (w <= 768) {
            setMobileMode(true);
            setControl((old) => ({ ...old, isMenuOpen: false }));
        } else {
            setMobileMode(false);
        }
    }

    useEffect(() => {
        var menuData = agentRouts
            .map((r: any) => r.parentId)
            .filter((item: any, index: number, array: any) => item && +item !== 7 && +item !== 3 && array.indexOf(item) === index)
            .map((ID: any) => ({
                ID,
                name: +ID === 1 ? "Balances" : +ID === 2 ? "Remittances" : +ID === 4 ? "Credits" : +ID === 5 ?
                    "CustomerManag" : +ID === 6 ? "CurrExchange" : +ID === 8 ? "RequestsAndOrders" : +ID === 9 ? "FrmAuctionDeliver" : "",
            }));
        if (menuData.find((r: any) => +r.ID === 2) === undefined && agentRouts.find((r: any) => +r.parentId === 3)) {
            menuData.push({ ID: 2, name: "Remittances" });
        }
        setControl((old) => ({
            ...old,
            menuData,
        }));
        setModel((old) => ({ ...old, menu: menuData }));
    }, []);

    const navigate = useNavigate();

    var path = useLocation().pathname;

    function openUrl(url: string) {
        if (url === "/Remitt/RemRec" && +options.RemOption === 1 && +options.IsCentralBank === 0) {
            url = "Remitt/RemittRec";
        }
        hideMenu();
        navigate(url);
    }

    async function UpdateMenu(item: any, goBack = false) {
        //تحديدشجرة الأباء للنافذة المفتوحة
        let tempNav: any = [];
        if (goBack) {
            tempNav = model.navigation.splice(
                0,
                model.navigation.findIndex((r) => r === item.name) + 1
            );
        } else if (+item.ID === 7) tempNav = ["HelpWindows"];
        else {
            //في حال كانت الصفحة الجديدة هي اول صفحة نفتحها من هذه القائمة نضيف اسمها مباشرة للناف و الا نحذف اسم اخر صفحة مفتوحة و نضيف الجديدة
            tempNav =
                model.parentName === model.navigation[model.navigation.length - 1]
                    ? [...model.navigation, item.name]
                    : [                        ...model.navigation.splice(0, model.navigation.length - 1),                        item.name,                    ];
        }
        //تحديد القائمة التي ستظهر أو النافذة التي سننتقل اليها
        var sons = agentRouts.filter((r:any) => r.parentId && +r.parentId === +item.ID);
        //اظهار قائمة
        if (sons.length > 1 || +item.ID === 2) {
            if (+item.ID === 2) sons.push({ ID: 3, name: "Queries" });
            tempNav.push(sons[0].name);
            setModel((old) => ({
                ...old,
                parentName: item.name,
                menu: sons,
                navigation: tempNav,
                Level: tempNav.length,
                ActiveIndex: 0,
            }));
            if (sons[0].path)
                openUrl(
                    sons[0].path + (sons[0].ulrParam ? "/" + sons[0].ulrParam : "")
                );
        }
        //الانتقال الى نافذة جديدة
        else {
            let element = sons && sons.length === 1 ? sons[0] : item;
            if (element.path) {
                setModel((old) => ({
                    ...old,
                    navigation: tempNav,
                    ActiveIndex: model.menu.findIndex((x:any) => x.name === element.name),
                }));
                openUrl(
                    element.path + (element.ulrParam ? "/" + element.ulrParam : "")
                );
            } 
        }
    }

    useEffect(() => {
        var pth = agentRouts.find((r: any) => r.path === path);

        if (pth === undefined) return;

        //في حال كانت النافذة المفتوحة موجودةو ضمن القائمة الحالية المعروضة فلانحدث القائمة
        if (model.menu.find((r: any) => pth.name === r.name) !== undefined) return;

        let item = +pth.parentId === 7 ? { ID: 7, name: "HelpWindows" } : +pth.parentId === 3 ? { ID: 3, name: "Queries" } : undefined;
        if (item === undefined) return;
        UpdateMenu(item);
    }, [path]);

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("resize", checkWidth);

        return () => window.removeEventListener("resize", checkWidth);
    }, []);

    function hideMenu() {
        if (mobileMode) {
            setControl((old) => ({ ...old, isMenuOpen: false }));
        }
    }

    return (
        <div style={{ height: "calc(100vh - 88px)" }} className="bg-body fade-in agent-layout">
            <AgentHeader
                menuButtonClicked={() =>
                    setControl((old) => ({ ...old, isMenuOpen: !old.isMenuOpen }))
                }
            />
            <div
                className={`bd-sidebar bg-body sidebar ${control.isMenuOpen ? "show" : "hide"
                    } ${appOptions.EnableLivePrices ? "enable-live-prices" : ""}`}
            >
                <AgentNavBar
                    Menu={model.menu}
                    Parentname={model.parentName}
                    Level={model.Level}
                    ActiveIndex={model.ActiveIndex}
                    ButtonClicked={(item:any) => {
                        UpdateMenu(item);
                        hideMenu();
                    }}
                    Back={() => {
                        if (model.parentName !== "Queries") {
                            setModel({
                                menu: control.menuData,
                                parentName: "",
                                Level: 0,
                                navigation: [],
                                ActiveIndex:-1
                            });
                            openUrl("/AgentDashboard");
                            return;
                        }

                        UpdateMenu({ ID: 2, name: "Remittances" }, true);
                    }}
                    HomeEvent={() => {
                        setModel({
                            menu: control.menuData,
                            parentName: "",
                            Level: 0,
                            navigation: [],
                            ActiveIndex:-1
                        });
                        openUrl("/AgentDashboard");
                    }}
                    ShowAgentInfo={control.showAgentInfo}
                    AgentInfoClicked={() =>
                        setControl((old) => ({
                            ...old,
                            showAgentInfo: !old.showAgentInfo,
                        }))
                    }
                />
            </div>
            <main
                className={`d-flex flex-xl-nowrap w-100 overflow-auto bg-body ${control.isMenuOpen ? "menu-open" : ""
                    }`}
            >
                <div className="card bg-body border-0 container-fluid mt-5">
                    <div className=" pt-2">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                {model.navigation.map((nav, index) => (
                                    <li
                                        className="h5 text-primary-emphasis fw-bold breadcrumb-item"
                                        key={index}
                                    >
                                        {app.translate(nav)}
                                    </li>
                                ))}
                            </ol>
                        </nav>
                    </div>
                    <div>
                        {props.children}
                    </div>
                </div>
            </main>
        </div>
    );
}